import {fsa, gateAction} from './helpers'
import {not} from '../utils'
import * as mobileMenu from '../store/mobileMenu'

export const CLOSE_MOBILE_MENU_ACCORDIONS = 'close all accordions in the mobile menu'
export const TOGGLE_MOBILE_MENU_ACCORDION = 'toggle an accordion in the mobile menu'
export const TOGGLE_MOBILE_MENU_ACCOUNT_MENU = 'toggle the account menu in the mobile menu'

export const CLOSE_MOBILE_MENU = 'close the mobile menu'
export const closeMobileMenu = fsa(CLOSE_MOBILE_MENU)

export const OPEN_MOBILE_MENU = 'open the mobile menu'
export const _openMobileMenu = fsa(OPEN_MOBILE_MENU)
export const openMobileMenu = gateAction(_openMobileMenu, mobileMenu.isOpen, not)

export function closeMobileMenuAccordions() {
  return {
    type: CLOSE_MOBILE_MENU_ACCORDIONS,
  }
}
export function toggleMobileMenuAccordion(accordionId) {
  return {
    type: TOGGLE_MOBILE_MENU_ACCORDION,
    accordionId,
  }
}

export function toggleMobileMenuAccountMenu() {
  return {
    type: TOGGLE_MOBILE_MENU_ACCOUNT_MENU,
  }
}
